/* Countdown (PRO system, snippets/pro-countdown.liquid)
   <pro-countdown data-end="seconds since 1970">: updates the days, hours,
   minutes and seconds left every second, in two digits at least (08). A
   unit ending in S drops it for 1 (01 DAY). Once the time passes it adds .is-ended (the rows hide and the
   ended text shows; with no ended text the countdown hides) and fires
   pro-countdown:end, which bubbles.
*/

if (!customElements.get('pro-countdown')) {
    class ProCountdown extends HTMLElement {
        connectedCallback() {
            this.end = Number(this.dataset.end) * 1000;
            this.values = Array.from(this.querySelectorAll('[data-countdown]'));
            this.units = Array.from(this.querySelectorAll('[data-countdown-unit]'));
            if (!this.end) return;
            this.tick();
            if (!this.classList.contains('is-ended')) this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
            clearInterval(this.timer);
        }

        tick() {
            const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
            const parts = {
                days: Math.floor(left / 86400),
                hours: Math.floor((left % 86400) / 3600),
                minutes: Math.floor((left % 3600) / 60),
                seconds: left % 60,
            };

            this.values.forEach((value, index) => {
                const number = parts[value.dataset.countdown];
                // Two digits at least: 08, not 8
                value.textContent = String(number).padStart(2, '0');
                const unit = this.units[index];
                if (!unit) return;
                const label = unit.dataset.label || '';
                // Not a lone S (seconds as "s"), which isn't a plural
                unit.textContent = number === 1 && /.s$/i.test(label) ? label.slice(0, -1) : label;
            });

            if (left > 0) return;
            clearInterval(this.timer);
            this.classList.add('is-ended');
            if (!this.querySelector('.pro-countdown__ended')) this.hidden = true;
            this.dispatchEvent(new CustomEvent('pro-countdown:end', { bubbles: true }));
        }
    }

    customElements.define('pro-countdown', ProCountdown);
}
